<div class="modal">
  <div class="modal__header">
    <div class="modal__icon-wrapper">
      <app-icon [icon]="iconName.CLOCK_EXPIRED" />
    </div>
  </div>

  <div class="modal__body">
    <h2 class="modal__title">
      {{ 'global-modals.sessionExpiredModal.title' | translate }}
    </h2>
    <p class="modal__desc">
      {{ 'global-modals.sessionExpiredModal.description' | translate }}
    </p>
  </div>

  <div class="modal__footer">
    <button class="modal__btn modal__btn--primary" (click)="onLogin()">
      {{ 'global-modals.sessionExpiredModal.loginBtn' | translate }}
    </button>
  </div>
</div>
